package model

sealed class LoginResponse {
    class Submitted: LoginResponse()
    class BypassLogin(val token: String): LoginResponse()
    class Error(val message: String): LoginResponse()
}